import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Delta from 'quill-delta';
import { List } from 'immutable';
import getOperationOffset from '../utils/getOperationOffset';
import convertMarksToAttributes from '../utils/convertMarksToAttributes';

function setMarksToNulls(marks) {
  return Object.entries(marks).reduce(function (memo, _ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return _objectSpread({}, memo, _defineProperty({}, key, null));
  }, {});
}

export default function removeMark(op, editor) {
  var node = editor.value.document.getNode(op.path);
  var marks = convertMarksToAttributes({
    marks: new List([op.mark])
  });
  return new Delta().retain(getOperationOffset(op, editor)).retain(node.text.length, setMarksToNulls(marks));
}